import axios from 'axios';

// Метка единственности сообщения о связи: их в очереди всегда не больше одного
const NET_TOAST_TAG = 'net';
// eslint-disable-next-line import/no-unresolved
// import router from 'router';

export default {
  methods: {
    baseAxios(props, updStatus = true) {
      return axios({
        headers: this.$store.getters.getToken ? { Authorization: `Bearer ${this.$store.getters.getToken}` } : {},
        method: props.method,
        url: props.url,
        data: props.data || ({}),
        params: props.params || ({}),
        // timeout: 10000,
        signal: props.signal || null,
        onDownloadProgress: (progressEvent) => {
          if (typeof props.onDownloadProgress === 'function') props.onDownloadProgress(progressEvent);
        },
      })
        .then(({ data }) => {
          if (updStatus) {
            // Сообщаем только о переходе, а не о каждом ответе: иначе тост
            // всплывал бы на любом успешном запросе.
            if (!this.$store.getters.isConnected) {
              this.$store.commit('removeToastByTag', NET_TOAST_TAG);
              this.$store.commit('pushToast', {
                text: this.$t('system.net_connected'),
                type: 'success',
                icon: 'exu-wifi',
                tag: NET_TOAST_TAG,
              });
            }
            this.$store.commit('updConnectionStatus', true);
          }
          return data;
        })
        // .finally(() => {})
        .catch((error) => {
          if (updStatus && error.code && error.code === 'ERR_NETWORK') {
            // Тост вешаем на переход, а не на каждый оборвавшийся запрос:
            // десять неудач подряд дают одно сообщение. Оно без таймера —
            // отсутствие связи это состояние, и снимет его возвращение связи.
            if (this.$store.getters.isConnected) {
              this.$store.commit('pushToast', {
                text: this.$t('system.net_unavailable'),
                type: 'danger',
                icon: 'exu-wifi-off',
                sticky: true,
                tag: NET_TOAST_TAG,
              });
            }
            this.$store.commit('updConnectionStatus', false);
          }
          if (this.$route.name !== 'loginView') {
            this.$store.commit('setLastUrl', { name: this.$route.name, params: this.$route.params });
          }
          // const { results } = error.response.data ? error.response.data : null;
          // silentErrors отключает авторедиректы: вызывающий разбирает статусы сам.
          // Нужно там, где общий сценарий уводит человека в тупик — например, при
          // входе по ссылке 401 увёл бы на логин с чужим текстом, а 423 на 404.
          if (error.response && props.silentErrors !== true) {
            const { results } = error.response.data;
            switch (error.response.status) {
              case 301:
                // TODO продумать структуру ответа на редирект
                if (results.redirect.appname === 'static-page') {
                  this.$router.push({ name: 'staticPage', params: { alias: results.redirect.page } });
                }
                break;
              case 401:
                if (this.$route.name !== 'loginView') {
                  this.$store.commit('setToken', null);
                  localStorage.removeItem('token');
                  this.$router.push({ name: 'loginView' });
                }
                return Promise.resolve({ results: { message: 'Неизвестный App ID' } });
                // break;
              case 403:
                console.log('403', error.response.status);
                this.$store.commit('setToken', null);
                localStorage.removeItem('token');
                this.$router.push({ name: 'loginView' });
                return Promise.resolve({ results: { message: 'Закрытый раздел' } });
                // break;
              case 404:
                console.log('to 404 page');
                this.$router.push({ name: 'page404' });
                break;
              case 423:
                console.log('to 423 page');
                localStorage.removeItem('exhID');
                this.$router.push({ name: 'page404' });
                break;
              case 418:
                console.error('Не понимаю... Может лучше выпьем чаю?');
                break;
              default:
                return Promise.reject(error);
                // return null;
                // break;
            }
          }
          return Promise.reject(error);
          // return null;
        });
    },
  },
};
